export default __webpack_public_path__ + "static/portfolioSample-df9e9b8b43eaf3cf3dbad990bfd10d9c.jpg";